import * as React from 'react';

const iconSrc = require('./chart.svg');

export const ChartFlatIcon: React.VFC = () => {
  return <img src={iconSrc} alt="chart icon" />;
};

ChartFlatIcon.displayName = 'ChartFlatIcon';
